import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { Event } from '@interfaces';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';
import { getButtons } from './get-buttons';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';


export function getSetup(util: UtilityService, dialogService: DialogService, accAreaService: AcceleratorAreaService): GridSetup<Event> {

	return {
		rowName: { singular: 'Event', plural: 'Events' },
		getRowKey: row => '' + row.eventId,
		stateKey: 'accelerator-events-grid',
		actions: getActions(dialogService, accAreaService),
		buttons: getButtons(dialogService, accAreaService),
		columns: getColumns(util),
	}
}
